export default __webpack_public_path__ + "static/media/introvert.7f43404a.svg";